import Vue from "vue";
import VueRouter from "vue-router";

import Menu from "@/views/setting/menu.vue";
import Dashboard from "../views/dashboard/dashboard.vue";
import profiles from "../views/dashboard/profile.vue";
import experientialData from "../views/idp-data/experientialData.vue";
import idpExamination from "../views/idp-examination/idp-examination.vue";
import Social from "../views/management-monitoring/social.vue";
import Structured from "../views/management-monitoring/structured.vue";
import BusinessUnit from "../views/master-data/business-unit/business-unit.vue";
import Coaching from "../views/master-data/coaching/coaching.vue";
import Competency from "../views/master-data/competency/competency.vue";
import CompetencyRole from "../views/master-data/competency-role/competency-role.vue";
import ProjectRole from "../views/master-data/project-role/project-role.vue";
import ProjectType from "../views/master-data/project-type/project-type.vue";
import TrainingMethod from "../views/master-data/training-method/training-method.vue";
import TrainingType from "../views/master-data/training-type/training-type.vue";
import Training from "../views/master-data/training/training.vue";
import MyIdp from "../views/myidp/myidp.vue";
import MyTNA from "../views/mytna/mytna.vue";
import ApprovalKtt from "../views/mytna/approval-ktt/main.vue";
import IdpApprovalKtt from "../views/myidp/approval-ktt/main.vue";
import IdpApprovalDeputyCoo from "../views/myidp/approval-deputy-coo/main.vue";
import IdpApprovalCoo from "../views/myidp/approval-coo/main.vue";
import MyTeamIdp from "../views/myteamidp/myteamidp.vue";
import idpPeriod from "../views/setting/idpPeriod.vue";
import tnaPeriod from "../views/setting/tna-period/tna-period.vue";
import menuManagement from "../views/setting/menuManagement.vue";
import UserRoleManagement from "../views/setting/user-role-management.vue";
import NotificationEvent from "../views/setting/notification-event/main.vue";
import NotificationTemplate from "../views/setting/notification-template/main.vue";
import Lsp from "@/views/master-data/lsp/lsp.vue";
import Ldp from "@/views/master-data/ldp/ldp.vue";
import Certificate from "@/views/master-data/certificate/certificate.vue";
import TrainingCategory from "@/views/master-data/training-category/training-category.vue";
import CourseMapping from "@/views/master-data/course-mapping/course-mapping.vue";
import CourseMappingMitra from "@/views/master-data/course-mapping-mitra/course-mapping-mitra.vue";
import PositionLevel from "@/views/master-data/position-level/position-level.vue";
import UserManagementMitra from "@/views/master-data/user-management-mitra/user-management-mitra.vue";
import SubconMapping from "@/views/master-data/subcon-mapping/subcon-mapping.vue";
import CourseCatalog from "@/views/master-data/course-catalog/course-catalog.vue";
import TNAMitra from "@/views/tna-mitra/tna-mitra.vue";
import MitraTNAReport from "@/views/mitra-tna-report/mitra-tna-report.vue";
import MitraEnrollment from "@/views/mitra-enrollment/mitra-enrollment.vue";
import MitraEnrollmentReport from "@/views/mitra-enrollment-report/mitra-enrollment-report.vue";
import MitraUnenrollmentReport from "@/views/mitra-unenrollment-report/mitra-unenrollment-report.vue";
import MitraUnenrollment from "@/views/mitra-unenrollment/mitra-unenrollment.vue";
import MitraAttendance from "@/views/mitra-attendance/mitra-attendance.vue";
import Attendance from "@/views/attendance/attendance.vue";
import AttendanceReport from "@/views/attendance-report/attendance-report.vue";
import TnaReport from "@/views/mytna/report/tna-report.vue";
import TnaReportDetail from "@/views/mytna/report/detail/tna-report-detail.vue";
import IdpEnrollment from "../views/idp/enrollment/main.vue";
import IdpUnEnrollment from "../views/idp/un-enrollment/main.vue";
import IdpEnrollmentReport from "../views/idp/enrollment-report/main.vue";
import CourseCalendar from "@/views/idp/course-calendar/main.vue";
import CourseCompletionMitra from "@/views/course-completion-mitra/course-completion-mitra.vue";
import CourseCompletionMitraReport from "@/views/course-completion-mitra-report/course-completion-mitra-report.vue";
import IdpUnEnrollmentReport from "../views/idp/un-enrollment-report/main.vue";
import CourseCompletion from "../views/idp/course-completion/main.vue";
import CertificateReview from "../views/certificate-review/main.vue";
import CourseCompletionReport from "../views/idp/course-completion-report/main.vue";
import IdpAttendance from "../views/idp/attendance/main.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "root",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/profile",
    name: "profile",
    component: profiles,
  },
  {
    path: "/master-data/competency",
    name: "competency",
    component: Competency,
  },
  {
    path: "/master-data/role-competency",
    name: "competencyRole",
    component: CompetencyRole,
  },
  {
    path: "/master-data/trainingMethod",
    name: "trainingMethod",
    component: TrainingMethod,
  },
  {
    path: "/master-data/trainingType",
    name: "trainingType",
    component: TrainingType,
  },
  {
    path: "/master-data/projectType",
    name: "projectType",
    component: ProjectType,
  },
  {
    path: "/master-data/projectRole",
    name: "projectRole",
    component: ProjectRole,
  },
  {
    path: "/master-data/coaching",
    name: "coaching",
    component: Coaching,
  },
  {
    path: "/master-data/training",
    name: "training",
    component: Training,
  },
  {
    path: "/master-data/business-unit",
    name: "businessUnit",
    component: BusinessUnit,
  },
  {
    path: "/tna/my-tna",
    name: "my-tna",
    component: MyTNA,
  },
  {
    path: "/tna/tna-report",
    name: "tna-report",
    component: TnaReport,
  },
  {
    path: "/tna/tna-report/:nik",
    name: "tna-report-detail",
    component: TnaReportDetail,
    props: true,
  },
  {
    path: "/tna/approval-ktt",
    name: "tna-approval-ktt",
    component: ApprovalKtt,
    props: true,
    meta: { public: true, layout: 'blank' }
  },
  {
    path: "/idp/approval-ktt",
    name: "idp-approval-ktt",
    component: IdpApprovalKtt,
    props: true,
    meta: { public: true, layout: 'blank' }
  },
  {
    path: "/idp/approval-deputy-coo",
    name: "idp-approval-deputy-coo",
    component: IdpApprovalDeputyCoo,
    props: true,
    meta: { public: true, layout: 'blank' }
  },
  {
    path: "/idp/approval-coo",
    name: "idp-approval-coo",
    component: IdpApprovalCoo,
    props: true,
    meta: { public: true, layout: 'blank' }
  },
  {
    path: "/master-data/lsp",
    name: "lsp",
    component: Lsp,
  },
  {
    path: "/master-data/ldp",
    name: "ldp",
    component: Ldp,
  },
  {
    path: "/master-data/certificate",
    name: "certificate",
    component: Certificate,
  },
  {
    path: "/master-data/training-category",
    name: "trainingCategory",
    component: TrainingCategory,
  },
  {
    path: "/master-data/course-mapping",
    name: "courseMapping",
    component: CourseMapping,
  },
  {
    path: "/master-data/course-mapping-mitra",
    name: "courseMappingMitra",
    component: CourseMappingMitra,
  },
  {
    path: "/master-data/position-level",
    name: "positionLevel",
    component: PositionLevel,
  },
  {
    path: "/master-data/user-management-mitra",
    name: "userManagementMitra",
    component: UserManagementMitra,
  },
  {
    path: "/master-data/subcon-mapping",
    name: "subconMapping",
    component: SubconMapping,
  },
  {
    path: "/master-data/course-catalog",
    name: "courseCatalog",
    component: CourseCatalog,
  },
  {
    path: "/tna-mitra",
    name: "tnaMitra",
    component: TNAMitra,
  },
  {
    path: "/mitra-tna-report",
    name: "mitraTNAReport",
    component: MitraTNAReport,
  },
  {
    path: "/mitra-enrollment",
    name: "mitraEnrollment",
    component: MitraEnrollment,
  },
  {
    path: "/mitra-enrollment-report",
    name: "mitraEnrollmentReport",
    component: MitraEnrollmentReport,
  },
  {
    path: "/mitra-attendance",
    name: "mitraAttendance",
    component: MitraAttendance,
  },
  {
    path: "/mitra-unenrollment-report",
    name: "mitraUnenrollmentReport",
    component: MitraUnenrollmentReport,
  },
  {
    path: "/mitra-unenrollment",
    name: "mitraUnenrollment",
    component: MitraUnenrollment,
  },
  {
    path: "/attendance/:sessionId?",
    name: "attendance",
    component: Attendance,
    meta: { public: true, layout: 'blank' }
  },
  {
    path: "/attendance-report",
    name: "attendanceReport",
    component: AttendanceReport,
  },
  {
    path: "/course-completion-mitra",
    name: "courseCompletionMitra",
    component: CourseCompletionMitra,
  },
  {
    path: "/course-completion-mitra-report",
    name: "courseCompletionMitraReport",
    component: CourseCompletionMitraReport,
  },
  {
    path: "/myidp",
    name: "myIdp",
    component: MyIdp,
  },
  {
    path: "/myteamidp",
    name: "myTeamIdp",
    component: MyTeamIdp,
  },
  {
    path: "/idpexamination",
    name: "idpExamination",
    component: idpExamination,
  },
  {
    path: "/idpManagement/structured-learning",
    name: "structured",
    component: Structured,
  },
  {
    path: "/idpManagement/social-learning",
    name: "social",
    component: Social,
  },
  {
    path: "/idpData/experiential-learning",
    name: "experientialData",
    component: experientialData,
  },
  {
    path: "/setting/idp-period",
    name: "idpPeriod",
    component: idpPeriod,
  },
  {
    path: "/setting/tna-period",
    name: "tnaPeriod",
    component: tnaPeriod,
  },
  {
    path: "/setting/menu-management",
    name: "menuManagement",
    component: menuManagement,
  },
  {
    path: "/setting/user-role-management",
    name: "userRoleManagement",
    component: UserRoleManagement,
  },
  {
    path: "/setting/menu",
    name: "menu",
    component: Menu,
  },
  {
    path: "/setting/notification-event",
    name: "notificationEvent",
    component: NotificationEvent,
  },
  {
    path: "/setting/notification-template",
    name: "notificationTemplate",
    component: NotificationTemplate,
  },
  {
    path: "/idp/enrollment",
    name: "idpEnrollment",
    component: IdpEnrollment,
  },
  {
    path: "/idp/un-enrollment",
    name: "idpUnEnrollment",
    component: IdpUnEnrollment,
  },
  {
    path: "/idp/enrollment-report",
    name: "idpEnrollmentReport",
    component: IdpEnrollmentReport,
  },
  {
    path: "/idp/un-enrollment-report",
    name: "idpUnEnrollmentReport",
    component: IdpUnEnrollmentReport,
  },
  {
    path: "/course-calendar",
    name: "courseCalendar",
    component: CourseCalendar,
  },
  {
    path: "/idp/course-completion",
    name: "courseCompletion",
    component: CourseCompletion,
  },
  {
    path: "/idp/course-completion-report",
    name: "courseCompletionReport",
    component: CourseCompletionReport,
  },
  {
    path: "/idp/attendance",
    name: "idpAttendance",
    component: IdpAttendance,
  },
  {
    path: "/certificate-review",
    name: "certificateReview",
    component: CertificateReview,
  },
  {
    path: "*",
    redirect: "/dashboard",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
